import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'; 
import plLocale from "@fullcalendar/core/locales/pl";
import enLocale from "@fullcalendar/core/locales/en-au";
import React from "react";
import { t } from "i18next";
import store from "../store";

export const FullCalendarComponent = ({addEventClick, eventClick, currentLocale, events, fetchDataForDateRange}) =>{
    const localeDefinition =[{
        lang : "pl",
        file: plLocale   
    },
    {
        lang : "en",
        file: enLocale   
    },
]
    const processedEvents = () => {
        events.map(el=>{
            if(el.title){
                const titleWithoutWhiteSpaces = el.title.replace(/ /g, '')
                el.classNames = [titleWithoutWhiteSpaces+"-event"]
            }
            el.display="block"
            el.title = el.title + " - " + getStatusLabel(el.status)
            el.backgroundColor = el.background?.value
            el.command = ()=>{};
            return el;
        })
        return events
    }
    const locales = ()=> {
        const locales = [];
        const companyLocale =  store.getState()?.companyLocale;
        if(companyLocale){
            const foundedLocale = localeDefinition.find(ld=>ld.lang === companyLocale);
            if(foundedLocale)locales.push(foundedLocale.file);
            else locales.push(foundedLocale.plLocale);
           return locales
        }
        return [localeDefinition[0].file]
    }
    const locale = () =>{
        const companyLocale =  store.getState()?.companyLocale;
        if(companyLocale){
            const foundedlocale = localeDefinition.find(el=>el.lang === companyLocale);
            if(foundedlocale){
                return foundedlocale.file;
            }
            return plLocale;
        }
        return localeDefinition[0].file
    }
    const headerToolbar =()=>{
        const headerToolbar={
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,dayGridWeek',
        }
        if(addEventClick){
            headerToolbar.left = 'prev,next,today,addButton'
        }
        return headerToolbar
    }  
    const customButtons = ()=>{
        const customButtons = {
            addButton: {
                id:"addButton",
              text: t("event.addEvent"),
              click: ()=>{addEventClick()},
            },
        }
        return customButtons
    }
    const getStatusLabel = (status) => {
        switch (status) {
            case 'DRAFT':
                return t("event.unpublished")
            default:
               return t("event.published")
        }
    }

    const handleDatesSet = (arg) => {
        const startDate = arg.start;
        const endDate = arg.end;
        console.log(`New date range: ${startDate} to ${endDate}`);
        // Tutaj możesz dodać logikę do pobrania danych na podstawie nowego zakresu dat
        fetchDataForDateRange(startDate, endDate);
    };

   

    return <FullCalendar 
                contentHeight={750}
                themeSystem="bootstrap5"
                events={processedEvents()}  
                locale={locale()}
                locales={locales()}
                headerToolbar={headerToolbar()}  
                customButtons={customButtons()}
                initialView='dayGridMonth'
                eventClick={eventClick}
                displayEventTime={false}
                plugins={[dayGridPlugin, timeGridPlugin]}
                datesSet={handleDatesSet}
            />
}